var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    height: "111.3px",
    viewBox: "0 0 1920 111.3",
    style: {
      enableBackground: "new 0 0 1920 111.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M697.1,91.5c594.1,135,1019.1,60.5,1222.9,22v87v110.7H0l0-110.7L0,7C0,7,135.3-36.1,697.1,91.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt01);
export default __webpack_public_path__ + "static/media/art01.479365d4d8f489b4c090ef098c6e8664.svg";
export { ForwardRef as ReactComponent };